var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHorizontalPositive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 100,
    viewBox: "0 0 500 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 100,
    rx: 15,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "grey",
    transform: "translate(0,30)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "60%",
    fontFamily: "'Poppins', sans-serif",
    fontSize: 36,
    textAnchor: "middle",
    fontWeight: 600,
    letterSpacing: 2
  }, "\n            K\xFCchenvermessung\n        "), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 212,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: -20,
    width: 12,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: -10,
    width: 12,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: -10,
    width: 12,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: -10,
    width: 12,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: -10,
    width: 12,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: -20,
    width: 12,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: -20,
    width: 12,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: -10,
    width: 12,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: -10,
    width: 12,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: -10,
    width: 12,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: -10,
    width: 12,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: -20,
    width: 12,
    height: 30
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontalPositive);
export default __webpack_public_path__ + "static/media/logo-horizontal-positive.9ed4ba6eb64ffcf725518e4ffdc34b42.svg";
export { ForwardRef as ReactComponent };